import { ButtonDestructive, ButtonPrimary } from "@nova/component-btn"
import { InspectorPanelMetadata } from "features/map/inspector-panel/FlightPanelMetadata"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import * as Icons from "@nova/component-icons"
import { VideoColorFinderFlight, VideoColorFinderJob } from "@nova/protobuf"
import { GenericUpload, SidePanelLayer } from "@nova/constants"
import { selectVideoUploads } from "features/entity-caching/images/video/selectors"
import { useVideoColorfinderProgress } from "../VideoColorFinder/preview-files/VideoColorfinderPreviewFiles"
import { selectVideoColorFinderJobByFlightId } from "../VideoColorFinder/ColorFinderSlice"
import { ProgressBar } from "panels/content/side-panel/upload-flow/components/UploadProgressBar"
import { openColorFinder } from "../V2/redux/slice"
import { deleteVideoColorFinderFlight } from "features/pubsub/entityActions/flights/videoColorFinder"
import {
    clearSelection,
    setActiveFeatureId,
    setActiveLayerId,
} from "panels/content/side-panel/slice.new"

export const ColorfinderVideoReferenceProcessing = ({
    flight,
    onDelete,
}: {
    flight: VideoColorFinderFlight
    onDelete: () => void
}) => {
    const dispatch = useAppDispatch()
    const videoId = flight.referenceVideoId!
    const uploads = useAppSelector(selectVideoUploads(videoId))
    const job = useAppSelector(
        selectVideoColorFinderJobByFlightId(flight.id)
    ) as VideoColorFinderJob

    const { processingProgress } = useVideoColorfinderProgress(flight.id)
    const isProcessingDone = processingProgress >= 1 && !!flight.job

    return (
        <>
            <div className="border-b border-gray-700" />
            {!isProcessingDone && (
                <ProgressBar
                    progress={processingProgress}
                    total={1}
                    timeElapsed={job?.createdAt as unknown as string}
                />
            )}
            {isProcessingDone && (
                <div className="flex items-center gap-1 my-4">
                    <Icons.Icon Icon={Icons.Checkmark} className="text-blue-500" />
                    <h5 className="text-gray-0">Processing Complete</h5>
                </div>
            )}
            <div className="mt-2">
                <InspectorPanelMetadata
                    entity={flight as SidePanelLayer}
                    uploads={uploads as GenericUpload[]}
                    hideCreator
                    hideFileCount={true}
                    completedUploadCount={0}
                    className=""
                    isSingleFile
                />

                <div className="border-b border-gray-700" />
                {/* action buttons */}
                {isProcessingDone && (
                    <ButtonPrimary
                        title={"View Color Data"}
                        RightIcon={Icons.ArrowRight}
                        className="w-full !px-0 mt-2"
                        onClick={() => {
                            dispatch(openColorFinder({ flightId: flight.id }))
                        }}
                    />
                )}
                <div className="flex gap-2 items-center mt-2">
                    <ButtonDestructive
                        onClick={() => {
                            dispatch(clearSelection())
                            dispatch(setActiveLayerId({ id: undefined }))
                            dispatch(setActiveFeatureId({ feature: undefined }))
                            dispatch(deleteVideoColorFinderFlight({ id: flight.id }))
                            onDelete()
                        }}
                        className="w-full !pl-3"
                        LeftIcon={Icons.Trash}
                        isTransparent
                    />
                </div>
            </div>
        </>
    )
}
